/**
 * 首页
 * 2017-12-6
 */
"use strict";
angular.module("passwordSettingModule", ["pwdStrengthModule","zoneServiceModule"]).
controller("passwordSettingCtrl", ["$scope", "httpService", "$q", "modalDialog", "$validation", "$element","zoneService", function($scope, httpService, $q, modalDialog, $validation, $element,zoneService) {
    initStatus();
    initData();

    function initStatus() {
    	$scope.status = {
           modes:0
        };
        $scope.data = {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            same: false,
            oldNew: false,
        }
    };
    /**
     * [initData description] 初始化状态
     * @return {[type]} [description]
     */
    function initData() {
        loadEncryptionLib().then(function() {
            encryptionMethods();
            requestData();
        });
    };
    
    /**
     * [requestData description] 初始化用户信息
     */
    function requestData() {
        $scope.loadingPromise = httpService.http("/mcnww/web/user/getLoginUser.do", "", "get").then(function(data) {
        	$scope.userinfo = data.loginUser;
        });
    };
    /**
     * [encryptionMethods description] 加密方法
     * @return {[type]} [description]
     */
    function encryptionMethods() {
        $.ajax({
            url: "/mcnww/web/user/publicKey.do",
            // headers:{requestToken:sessionStorage.getItem('requestToken'),"Content-Type":"text/plain;charset=UTF-8"},
            dataType: "text",
            success: function(data) {
                $("#encryption").remove();
                $("body").append("<script id='encryption'>" + data + "</script>");
            }
        });
    }
    /**
     * [loadEncryptionLib description] 加载加密依赖文件
     * @return {[type]} [description]
     */
    function loadEncryptionLib() {
        var deffer = $q.defer();
        LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function() {
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [savePwd description] 保存修改
     * @return {[type]} [description]
     */
    $scope.save = function() {
        if ($scope.data.confirmPassword != $scope.data.newPassword){
            $scope.data.same = false;
        }
        if ($scope.data.newPassword !== $scope.data.confirmPassword) return;
        if ($scope.status.modes == 1){
        	$scope.isShowTipsB = true;
        	return;
        }
        var params = {
            oldPassword: encryptedString(bodyRSA(), $scope.data.oldPassword),
            password: encryptedString(bodyRSA(), $scope.data.newPassword),
            confirmPassword: encryptedString(bodyRSA(), $scope.data.confirmPassword)
        };
        $validation.validate($scope.changePwdForm).success(function() {

            httpService.http("/mcnww/web/ucenter/resetPassword.do", params, "post").then(function(result) {
                modalDialog.success("密码修改成功", "success", false, function() {});
            });
        }).error(function() {
            angular.invalidPosition($scope.changePwdForm, $element);
        });

    }
        /**
         * [forgetPassword description] 忘记密码
         * @return {[type]} [description]
         */
    $scope.forgetPassword = function() {
        window.open("/mcnww/web/user/resetpwd.do");
    };
    /**
     * [regularIf description] 判断是否显示正确图标
     * @return {[type]} [description]
     */
    $scope.regularIf = function(key, value) {
        switch (key) {
            case 1: //原密码
                $scope.showTipsA = true;
                break;

            case 2: //确认密码
                $scope.showTipsC = true;
                $scope.data.isShowTipsCc = false;
                $scope.data.same = false;
                break;
             case 3: //原密码
                $scope.showTipsB = true;
                $scope.data.same = false;
                break;
        }
        $validation.validate($scope.changePwdForm[value]).success(function() {
            switch (key) {
                case 2:
                    if (!$scope.data.confirmPassword) return;
                    else if ($scope.data.confirmPassword != $scope.data.newPassword) {
                        $scope.data.same = true;
                        return;
                    } else {
                        $scope.data.same = false;
                    }
                    break;
                case 3:
                    if (!$scope.data.confirmPassword) return;
                    else if ($scope.data.confirmPassword != $scope.data.newPassword) {
                        $scope.data.same = true;
                        return;
                    } else {
                        $scope.data.same = false;
                    }
                    break;
            }
        });
    };
	/**
     * [changeNumber description] 更换号码
     * @return {[type]} [description]
     */
    $scope.changeNumber = function() {
        zoneService.changeNumber($scope.status).then(function(data) {
            requestData();
        });
    };
}]);
